import React from 'react';
import PageTitle from '../components/pagetitle/PageTitle';

import { Link } from 'react-router-dom';

function AboutUs(props) {
    return (
        <div>
            <PageTitle none='none'  title='About Us' />

            <section className="tf-add-nft">
                <div className="tf-container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="add-nft-inner">
                                <h6 className="title">Who We Are</h6>
                                <p className="sub">D.T Wallet is India's leading digital voucher marketplace, revolutionizing how people purchase, store, and redeem brand vouchers. We provide a secure, convenient platform that brings together top brands and smart shoppers in one unified ecosystem.</p>

                                <h6 className="title">Our Mission</h6>
                                <p className="sub">To simplify digital voucher management and create a seamless experience for users to access their favorite brands. We believe in transparency, security, and customer satisfaction above all else.</p>

                                <h6 className="title">What We Offer</h6>
                                <ul className="collection-list">
                                    <li>
                                        <div className="list">
                                            <div className="infor">
                                                <p>Digital Voucher Marketplace</p>
                                                <h6>Purchase vouchers from hundreds of trusted brands across categories including retail, food, entertainment, and lifestyle.</h6>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="list">
                                            <div className="infor">
                                                <p>Secure Storage & Management</p>
                                                <h6>Store all your vouchers in one secure digital dashboard. Access them anytime, anywhere with complete peace of mind.</h6>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="list">
                                            <div className="infor">
                                                <p>Instant Digital Delivery</p>
                                                <h6>Receive your vouchers instantly after payment confirmation. No waiting, no physical cards, just instant access.</h6>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="list">
                                            <div className="infor">
                                                <p>Easy Redemption Process</p>
                                                <h6>Redeem vouchers seamlessly at partner outlets or online platforms with simple QR codes or voucher codes.</h6>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <h6 className="title">Why Choose D.T Wallet</h6>
                                <p className="sub">Unlike traditional wallet apps, D.T Wallet is purely a voucher marketplace. We do not store money, provide wallet balances, or enable fund transfers. This focused approach allows us to deliver the best voucher management experience without the complexity of financial services.</p>

                                <h6 className="title">Our Commitment</h6>
                                <ul className="collection-list">
                                    <li>
                                        <div className="list">
                                            <div className="infor">
                                                <p>Security First</p>
                                                <h6>Your data is protected with industry-standard encryption. We never sell your information to third parties.</h6>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="list">
                                            <div className="infor">
                                                <p>Transparent Policies</p>
                                                <h6>Clear terms, honest communication, and fair refund policies. No hidden charges or surprise fees.</h6>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="list">
                                            <div className="infor">
                                                <p>24/7 Customer Support</p>
                                                <h6>Our dedicated support team is always ready to assist you with any questions or concerns.</h6>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="list">
                                            <div className="infor">
                                                <p>Trusted Partnerships</p>
                                                <h6>We partner only with verified brands to ensure authenticity and reliability of every voucher.</h6>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <h6 className="title">Get Started Today</h6>
                                <p className="sub">Join thousands of satisfied users who trust D.T Wallet for their digital voucher needs. Create your account, browse our extensive brand collection, and start saving today.</p>

                                <div className="bottom-button">
                                    <Link to="/contact" className="tf-button active">Contact Us</Link>
                                    <Link to="/policies" className="tf-button">View Policies</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </section>
            
        </div>
    );
}

export default AboutUs;